// extracted by mini-css-extract-plugin
export default {"chart":"BarChart_chart__-16Ac"};